export const PromptTypes = {
  None: 0,
  System: 1,
  Assistant: 2,
  User: 3,
} as const

export type PromptType = (typeof PromptTypes)[keyof typeof PromptTypes]

const PromptTypeNames: Record<PromptType, string> = {
  [PromptTypes.None]: 'None',
  [PromptTypes.System]: 'System',
  [PromptTypes.Assistant]: 'Assistant',
  [PromptTypes.User]: 'User',
}

export function getPromptTypeName(type: PromptType): string {
  return PromptTypeNames[type]
}

export const TestStages = {
  None: 0,
  Start: 1,
  TestResultComplete: 2,
  PersonalInfoComplete: 3,
  WebDiagramComplete: 4,
  HistogramComplete: 5,
} as const

export type TestStage = (typeof TestStages)[keyof typeof TestStages]

const TestStageNames: Record<TestStage, string> = {
  [TestStages.None]: 'None',
  [TestStages.Start]: 'Start',
  [TestStages.TestResultComplete]: 'TestResultComplete',
  [TestStages.PersonalInfoComplete]: 'PersonalInfoComplete',
  [TestStages.WebDiagramComplete]: 'WebDiagramComplete',
  [TestStages.HistogramComplete]: 'HistogramComplete',
}

export function getTestStageName(stage: TestStage): string {
  return TestStageNames[stage]
}

export const Roles = {
  Admin: 'Admin',
  User: 'User',
  CareerGuidanceSpecialist: 'CareerGuidanceSpecialist',
  Agent: 'Agent',
} as const

export type Roles = (typeof Roles)[keyof typeof Roles]

export const PaymentMethods = {
  None: 0,
  TipTop: 1,
  KaspiRemotePhone: 2,
} as const
export type PaymentMethod = (typeof PaymentMethods)[keyof typeof PaymentMethods]
